<template>
	<page-container
		:page="page"
		:class="{
			'has-landscape-video': page.vimeoIDLandscape,
			'has-portrait-video': page.vimeoIDPortrait,
		}"
	>
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<video-header v-if="page.vimeoIDLandscape" :video="page.vimeoIDLandscape" type="landscape" />

		<video-header v-if="page.vimeoIDPortrait" :video="page.vimeoIDPortrait" type="portrait" />

		<main-content
			v-if="!page.introblock"
			:title="page.title || page.header"
			:content="page.content"
			:intro-image="{
				image: page.introductionImage,
				imageWebp: page.introductionImageWebp,
			}"
		/>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<section class="main-content">
			<div class="row contact-form-row">
				<div class="form-inner-wrapper row">
					<div class="columns column8 contact-form-col">
						<h2 class="align-center">{{ defaults[locale].contact.eventFormHeader }}</h2>
						<contact-form class="grid-columns-4" name="events" :form="form" />
					</div>
				</div>
			</div>
		</section>

		<intro-block v-if="page.introblock" :item="page.introblock" />

		<usp-block
			v-if="page.uSPBlock"
			:header="page.uSPBlock.header"
			:items="page.uSPBlock.items"
			:button="{
				text: page.uSPBlock.button,
				link: page.uSPBlock.buttonLink,
			}"
		/>

		<contentblocks :items="page.contentblocks" />

		<frequently-asked-questions v-if="page.faqs && page.faqs.length" :items="page.faqs" />

		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchDefaults();
await fetchPage();

const { data: form } = await useWebsiteFetch('events', {
	query: { language: locale.value },
	key: `${locale.value}/events`,
});
</script>

<style lang="scss">
.contact-form-col {
	margin: 0 auto 50px;
}
</style>
